module.exports = __webpack_public_path__ + "img/nodeBackgroundGridWhite.346fbfbc.svg";